(function($) {

	function checkform() {

		var submit = true;

		var num = $('.gfield_list .gfield_list_group').length;
		if(num < 4 ) submit = false; 

		$('.gfield_list_group input').each(function() {
			if(!$(this).val()) submit = false; 
		});

		if(!submit){
			$('.gfield_list').closest('.gfield').addClass('gfield_error');
			return false;
		}

		$(".booking-form form").trigger("submit",[true]);
		if(window["gf_submitting_1"]){return false;}
		window["gf_submitting_1"]=true;
	}

	// $('.gfield_list_group input').on('focus',function() {
	// 	$('.gfield_list').closest('.gfield').removeClass('gfield_error');
	// });
	//
	// $(".gform_button").onclick = null;
	// $('.gform_button').on('click', function(event) {
	// 	event.preventDefault();
	// 	checkform();
	// });
	//
	// $(".gform_button").onkeypress = null;
	// $('.gform_button').on('keypress', function(event) {
	// 	event.preventDefault();
	// 	if( event.keyCode == 13 ){
	// 		checkform();
	// 	}
	// });

	$(document).on('gform_post_render',function(event, form_id, current_page) {
		if($('.gform_wrapper.guest-booking_wrapper').length){

			$(".gform_button").onclick = null;
			$('.gform_button').on('click', function(event) {
				event.preventDefault();
				checkform();
			});

			$(".gform_button").onkeypress = null;
			$('.gform_button').on('keypress', function(event) {
				event.preventDefault();
				if( event.keyCode == 13 ){
					checkform();
				}
			});

			$('.gfield_list_group input').on('focus',function() {
				$('.gfield_list').closest('.gfield').removeClass('gfield_error');
			});

		}
	});

})(jQuery);
